module.exports = __webpack_public_path__ + "static/media/temperature-control-in-place.03eac9c5.svg";